// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreateOrRequestQuote,
    ExecuteOnSuccessCallback,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";
import { createQuoteAsOrder } from "@keller/App/Services/QuoteService";

/**
 * XNG-Changes:
 * Change the behavior on the submit quote screen to let the button call the same API for the place order (api/v1/carts/current => patch)
 *
 * Ticket: https://xngage.atlassian.net/browse/KSC-466
 *
 * @param props
 * @constructor
 */
export const XngPopulateApiParameter = (props: any) => {
    const quoteParameter = props.getState().pages.rfqRequestQuote.quoteParameter;
    const { quoteId, jobName, quoteType, accountId, note } = quoteParameter;
    props.apiParameter = {
        id: quoteId,
        status: "submitted",
        notes: note,
        PoNumber: jobName,
        properties: {
            isJobQuote: quoteType === "job",
            userId: accountId,
            isQuoteSubmit: true,
        },
    };
};

export const XngCreateOrRequestQuote = async (props: any) => {
    const { parameter, apiParameter } = props;
    const result = await createQuoteAsOrder(apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const XngExecuteOnSuccessCallback = (props: any) => {
    props.parameter.onSuccess?.(props.apiResult.id);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, CreateOrRequestQuote, XngCreateOrRequestQuote);
replaceInChain(chain, ExecuteOnSuccessCallback, XngExecuteOnSuccessCallback);
